const formFieldConfig = {
    editDisplayPath: {
        fields: [
            'adult',
            'adultLevel',
            'amsProgram.echostarId',
            'displayPath',
            'displayPathImageCategory',
            'images',
            'networkDisplayPathId',
            'status',
        ],
        customPathFields: ['networkDisplayPathId'],
    },
    editDisplayPathModifier: {
        fields: [
            'dateCreated',
            'description',
            'match',
            'method',
            'network',
            'networkDisplayPathModifierId',
            'priority',
            'transformation',
        ],
        customPathFields: ['networkDisplayPathModifierId'],
    },
    editNetwork: {
        fields: [
            'adDecisioningSystem',
            'adInsertionEnabled',
            'allowed',
            'alternateName',
            'bingeable',
            'crossServiceMappingEnabled',
            'callSigns',
            'caid',
            'csidSiteSectionPrefix',
            'csidSiteSectionSuffix',
            'description',
            'fastPath',
            'freewheelNetworkName',
            'mrmProdId',
            'mrmTestId',
            'name',
            'networkId',
            'notificationEmail',
            'secondaryAdProviderEnabled',
            'sfidSiteSectionPrefix',
            'sfidSiteSectionSuffix',
            'tmsAutomappingEnabled',
            'selfContentOwnerEnabled',
            'fwCaidPrefixEnabled',
        ],
        customPathFields: ['guid'],
    },
    editNetworkImage: {
        fields: [
            'adDecisioningSystem',
            'adInsertionEnabled',
            'allowed',
            'alternateName',
            'bingeable',
            'callSigns',
            'caid',
            'crossServiceMappingEnabled',
            'csidSiteSectionPrefix',
            'csidSiteSectionSuffix',
            'description',
            'fastPath',
            'freewheelNetworkName',
            'image',
            'mrmProdId',
            'mrmTestId',
            'name',
            'networkId',
            'notificationEmail',
            'secondaryAdProviderEnabled',
            'sfidSiteSectionPrefix',
            'sfidSiteSectionSuffix',
            'tmsAutomappingEnabled',
            'selfContentOwnerEnabled',
            'fwCaidPrefixEnabled',
        ],
        customPathFields: ['guid'],
        addFields: [
            {
                name: 'image',
                value: {
                    category: 'NETWORK_LOGO',
                    finalResourceName: '',
                    mimeType: 'image/jpeg',
                    primary: false,
                    rawResourceUri: '',
                    state: 'UPLOADED_REMOTE',
                    version: 0,
                },
                overwrite: true,
            },
        ],
    },
    editProvider: {
        fields: ['guid', 'name', 'partnerId', 'playerType'],
        customPathFields: ['partnerId'],
    },
    editRole: {
        fields: ['childRoles', 'name', 'roleId'],
        customPathFields: ['roleId'],
    },
    editShell: {
        fields: [
            'commonSense',
            'commonSenseId',
            'credits',
            'description',
            'descriptionLanguage',
            'documentId',
            'echostarContentType',
            'echostarEpisodeId',
            'echostarEventString',
            'echostarId',
            'echostarSeriesId',
            'episodeNumber',
            'episodeSeason',
            'genres',
            'guid',
            'images',
            'extra',
            'lastUpdate',
            'locked',
            'originalAirDate',
            'rating',
            'ratingBody',
            'releaseYear',
            'retired',
            'rottenTomato',
            'roviProgramId',
            'runtime',
            'seriesId',
            'seriesTitle',
            'shortDescription',
            'title',
            'titleLanguages',
        ],
    },
    editUser: {
        fields: ['active', 'clientId', 'email', 'name', 'scope'],
    },
    editVfb: {
        fields: ['bingeable', 'exactEpisodicSequencing', 'dumbBookmarkOffset', 'dumbAutoplayCountdown'],
        fieldsPath: ['vfb'],
    },
};

export default formFieldConfig;
